import { useEffect } from 'react'

import { UPDATE_LOCKS } from '@/client/services/update/constants'

export default function useLockUpdate() {
  useEffect(() => {
    const lockRef = {}
    UPDATE_LOCKS.add(lockRef)

    return () => {
      UPDATE_LOCKS.delete(lockRef)
    }
  }, [])
}
